import React from 'react';
import { Button, Col, InputGroup, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Form, Formik } from 'formik';

import { FormikControl } from '@components/Base';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export type UserControlFormValues = { search: string };

const FormForm = () => {
  const { t } = useTranslation();

  return (
    <Form>
      <Row className="justify-content-end py-2">
        <Col md={6}>
          <InputGroup>
            <FormikControl name="search" isValid={false} isInvalid={false} placeholder={t('user.search')} />
            <Button type="submit">
              <FontAwesomeIcon icon={faSearch} />
            </Button>
          </InputGroup>
        </Col>
      </Row>
    </Form>
  )
}

type Props = {
  initialValues: UserControlFormValues;
  onSubmit: (values: UserControlFormValues) => void;
}

const UserControlForm = ({ initialValues, onSubmit }: Props) => {
  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit} >
      <FormForm />
    </Formik >
  );
}

export { UserControlForm };
